import { Cards } from '../../../components/cards/frame/cards-frame';
import clockImg from '../../../static/img/dashboard/icon-clock.svg';
function Time() {
 
    const timeData = [
            {
                "id": "login_time",
                "label": "Last Day Login Time",
                "value": "09:08 AM"
            },
            {
                "id": "logout_time",
                "label": "Last Day Logout Time",
                "value": "06:22 PM"
            },
            {
                "id": "last_day_hours",
                "label": "Last Day Total Login Hours",
                "value": "08h 41m"
            },
            {
                "id": "seven_days_hours",
                "label": "7 Days Total Login Hours",
                "value": "49h 10m"
            },
            {
                "id": "month_login_hours",
                "label": "Total Login Hours This Month",
                "value": "186h 24m"
            },
            {
                "id": "total_present",
                "label": "Total Present Day",
                "value": "22"
            },
            {
                "id": "total_half_day",
                "label": "Total Half Day",
                "value": "2"
            },
            {
                "id": "total_absent",
                "label": "Total Absent in Month",
                "value": "3"
            }
    ]
  return (
    <div className="stats-row-container">
      {timeData.map((item) => (
        <div key={item.id} className="stat-card">
          <div className="stat-icon-wrapper">
            <img src={clockImg} alt="Clock" />
          </div>
          <div className="stat-details">
            <span className="stat-label">{item.label}</span>
            <span className="stat-value">{item.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Time;
